import { SearchInstallment } from "../../services/modules/loan";
import { useFetch } from "./config";

export function useSearchInstallment(borrowerId) {
  return useFetch({
    queryKeys: ["search installment", borrowerId],
    queryFn: async () => {
      if (!borrowerId) return [];
      const { resultData } = await SearchInstallment({
        body: { borrower_id: borrowerId },
      });
      return resultData[0]?.borrower_data;
    },
  });
}
